import { render, staticRenderFns } from "./SortOneMany.vue?vue&type=template&id=1d8c4b09&lang=pug&"
import script from "./SortOneMany.vue?vue&type=script&lang=js&"
export * from "./SortOneMany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports